export default {

    coffeeData: {
        windBreaker: "Arbre Brise-Vent",
        horticultureInfo: "Arbre Horticole",
        shadeTree: "Arbre d'Ombre",
        coffeeVariety: "Variété de Café",
        coffeeSpecies: "Espèce de Café",
        updateWindBreaker: "Mettre à jour le type d'arbre brise-vent",
        addWindBreaker: "Ajouter un nouveau type d'arbre brise-vent",
        updateHorticultureInfo: "Mettre à jour le type d'arbre horticole",
        addHorticultureInfo: "Ajouter un nouveau type d'arbre horticole",
        updateShadeTree: "Mettre à jour le type d'arbre d'ombre",
        addShadeTree: "Ajouter un nouveau type d'arbre d'ombre",
        updateCoffeeVariety: "Mettre à jour le type de variété de café",
        addCoffeeVariety: "Ajouter une nouvelle variété de café",
        deleteVarietyTitle: "Supprimer la variété",
        deleteVarietyMessage: "Êtes-vous sûr de vouloir supprimer la variété ?",
        updateCoffeeSpecie: "Mettre à jour l'espèce de café",
        deleteSpecieTitle: "Supprimer l'espèce",
        deleteSpecieMessage: "Êtes-vous sûr de vouloir supprimer l'espèce ?",
        addCoffeeSpecie: "Ajouter une nouvelle variété de café",
        variety: "Variété",
        selectVariety: "Sélectionner l'espèce",
        deleteCoffeeRecord: "Êtes-vous sûr de vouloir supprimer l'enregistrement ?",
        deleteCoffeeData: "Supprimer les données de café",
        topicRequired: "La sélection du sujet est obligatoire",
        coffeeAddSuccess: "Espèce de café ajoutée avec succès.",
        treeTypeSuccess: "Type d'arbre ajouté avec succès.",
        treeTypeUpdateSuccess: "Type d'arbre mis à jour avec succès.",
        coffeeVarietySuccess: "Variété de café ajoutée avec succès.",
        coffeeSpecieSuccess: "Espèce de café mise à jour avec succès.",
        nameRequired: "Le nom est obligatoire",
        notFound: "Aucune donnée d'admin de café trouvée",
    },
    cacaoData: {
        cacao: "Cacao",
        cacaoVariety: "Variété de cacao",
        cacaoSpecies: "Espèce de cacao",
        cacaoWeight: "Poids du cacao",
        cacaoOverview: "Aperçu du cacao",
        buysellOverview: "Aperçu des achats/ventes",
        cacaoType: "Type de cacao",
        deleteCacaoData: "Supprimer les données du cacao",
        productWeight: "Poids du produit",
        productType: "Type de produit",
        productPricePerKg: "Prix par KG",
        registerFermentation: "Enregistrer la fermentation",
        batchVisualIdentification: "Identification visuelle du lot",
        initialWeight: "Poids initial",
        finalWeight: "Poids final",
        performance: "Performance",
        fermentationPercentage: "Pourcentage de fermentation",
        fermetationMethod: "Méthode de fermentation",
        boxes: "Boîtes",
        piles: "Piles",
        bags: "Sacs",
        selectZone: "Sélectionner la zone",
        selectPlantation: "Sélectionner la plantation",
        deliveryMethod: "Méthode de livraison",
        totalPrice: "Prix total",
      },
    memberDataSection: {
        import: "Importer",
        buyingStation: "Station d'achat",
        factory: "Usine",
        factories: "Usines",
        factoryInfo: "Info Usine",
        continue: "Continuer",
        farmerId: "ID Agriculteur",
        farmerName: "Nom de l'Agriculteur",
        farmerAddress: "Adresse de l'Agriculteur",
        quality: "Qualité",
        quantity: "Quantité",
        importAll: "Tout importer",
        importSelected: "Importer sélectionné",
        fileLoaded: "Fichier chargé avec succès",
        incorrectHeaders: "En-têtes incorrects",
        processingBatch: "Traitement du lot",
        purchaseOrder: "Bon de commande",
        startDate: "Date de début",
        endDate: "Date de fin",
        purchasingOrder: "Ordre d'achat",
        totalCoffeeCherry: "Total des cerises de café",
        airHumidity: "Humidité de l'air",
        density: "Densité",
        temperature: "Température",
        beanMoistureContent: "Teneur en humidité des grains",
        processType: "Type de processus",
        batchRating: "Sélectionner la note du lot",
        purchaseDate: "Date d'achat",
        selectFarmer: "Sélectionner l'agriculteur",
        selectFarmers: "Sélectionner les agriculteurs",
        selectFarm: "Sélectionner la ferme",
        selectPlantation: "Sélectionner la plantation",
        coffeeVariety: "Variété de café",
        coffeeSpecies: "Espèce de café",
        coffeeCherryQuantity: "Quantité de cerises de café",
        coffeeCherryQuality: "Qualité des cerises de café",
        coffeeType: "Type de café",
        pricePerKg: "Prix par kg",
        processingDone: "Traitement effectué",
        processedCoffeeOut: "Café traité sortant",
        farmer: "Agriculteur",
        farm: "Ferme",
        plantation: "Plantation",

        farmers: "Agriculteurs",
        farmLimitUsed: "Limite de la ferme utilisée",
        phoneNumber: "Numéro de téléphone",
        farmSize: "Taille de la ferme",
        farmLocation: "Ferme/Localisation",
        date: "Date",
        status: "Statut",
        noFarmers: "Aucun agriculteur trouvé",
        approveReject: "Approuver/Rejeter",
        farms: "Fermes",
        crops: "Cultures",
        equipment: "Équipement",
        noFarms: "Aucune ferme trouvée",
        views: "Voir",
        selectStatus: "Sélectionner le statut",
        approved: "Approuvé",
        rejected: "Rejeté",
        reject: "Rejeter",
        approve: "Approuver",
        cancel: "Annuler",
        add: "Ajouter",
        describeYourReason: "Décrivez votre raison ici",
        userInformation: "Informations de l'utilisateur",
        userFarmRequest: "Demande de ferme de l'utilisateur",
        userFarmInformation: "Informations sur la ferme de l'utilisateur",
        activity: "Activité",
        activityType: "Type d'activité",
        farmZone: "Zone de ferme",
        farmerView: "Vue de l'agriculteur",
        cropType: "Type de culture",
        cropVarity: "Variété de culture",
        area: "Superficie",
        cost: "Coût",
        geofence: "Géofence",
        map_views: "Vue de la carte",
        viewAllFarms: "Voir toutes les fermes",
        farmersDetails: "Détails de l'agriculteur",
        download: "Télécharger",
        pOrder: {
            addNew: "Ajouter Nouveau",
            viewAll: "Voir tout",
            selectDate: "Sélectionner une date",
            makeSelection: "Faites une sélection",
            coffeeType: "Type de quantité de café",
            enterPrice: "Entrez le prix",
            reqPurchaseDate: "La date d'achat est obligatoire",
            reqFarmer: "L'agriculteur est obligatoire",
            reqCoffeeQnty: "La quantité de cerises de café est obligatoire",
            reqPrice: "Le prix par kg est obligatoire",
            grandTotal: "TOTAL GÉNÉRAL",
            selectDateRange: "Sélectionner une plage de dates",
            import: "Importer",
            purchaseId: "ID d'achat",
            purchaseDate: "Date d'achat",
            farmerName: "Nom de l'agriculteur",
            quality: "Qualité",
            quantity: "Quantité",
            pricePerKg: "Prix par kg",
            selectBuyingStation: "Sélectionner la station d'achat",
            searchUser: "Rechercher des utilisateurs",
            purchaseListView: "Vue de la liste des achats",
            viewBy: "Voir par",
            typeDensity: "Tapez la densité",
            typeTemperature: "Tapez la température",
            typeWaterContent: "Tapez la teneur en eau",
        },
        farmActivity: "Activité agricole",
        showOnMap: "Afficher sur la carte",
        farmInformation: "Informations sur la ferme",
        dateOfEntry: "Date d'entrée",
        farmID: "ID de la ferme",
        ownershipType: "Type de propriété",
        locationAddress: "Adresse du lieu",
        goalType: "Type d'objectif",
        totalSize: "Taille totale",
        zones: "Zones",
        farmActivities: "Activités agricoles",
        farmDetails: "Détails de la ferme",
        totalFarmsRegistered: "Total des fermes enregistrées",
        totalFarmArea: "Superficie totale de la ferme",
        totalZone: "Zone totale",
        zone: "Zone",

        totalCost: "Coût total",
        selectFarmZone: "Sélectionner une zone/ferme",
        productionType: "Type de production",
        certifications: "Certifications",
        geofences: "Géofences",
        farmsChart: "Graphique des fermes",
        
        // Buying Station specific translations
        buyingStations: "Stations d'Achat",
        registerBuyingStation: "Enregistrer Station d'Achat",
        registerFactory: "Enregistrer Usine",
        loadingFactory: "Chargement de l'Usine...",
        loadingBuyingStation: "Chargement de la Station d'Achat...",
        searchBuyingStation: "Rechercher Station d'Achat",
        searchFactory: "Rechercher Usine",
        nameAndId: "Nom / ID",
        email: "Email",
        mobileNumber: "Numéro Mobile",
        role: "Rôle",
        actions: "Actions",
        view: "Voir",
        edit: "Modifier",
        activate: "Activer",
        deactivate: "Désactiver",
        operator: "Opérateur",
        supplier: "Fournisseur",
        active: "Actif",
        deactivated: "Désactivé",
        activatedSuccessfully: "Station d'achat activée avec succès",
        deactivatedSuccessfully: "Station d'achat désactivée avec succès",
        factoryActivatedSuccessfully: "Usine activée avec succès",
        factoryDeactivatedSuccessfully: "Usine désactivée avec succès",
        factoryRegisteredSuccessfully: "Usine enregistrée avec succès",
        deletedSuccessfully: "Station d'achat supprimée avec succès",
        duplicatedSuccessfully: "Station d'achat dupliquée avec succès",
        confirmDialog: {
            delete: {
                title: "Supprimer Station d'Achat",
                message: "Êtes-vous sûr de vouloir supprimer cette station d'achat?",
                confirmBtn: "Supprimer",
            }
        },
        registerNewFactory: "Enregistrer Nouvelle Usine",
        selectHowYouWantToProceed: "Sélectionnez comment vous souhaitez procéder",
        single: "Unique",
        multiple: "Multiple",
        user: "Utilisateur",
        createNewFactory: "Créer une Nouvelle Usine",
        factoryName: "Nom de l'Usine",
        factoryNumber: "Numéro d'Usine",
    },
}
